import { colord } from "colord"
import { ReactNode } from "react"
import { twMerge } from "tailwind-merge"

interface ThemeType {
  [key: string]: {
    bg: string
    text: string
    hex: string
  }
}

export const THEMES: ThemeType = {
  none: {
    bg: "",
    text: "",
    hex: "#ffffff",
  },
  black: {
    bg: "bg-black",
    text: "text-black",
    hex: "#222222",
  },
  yellow: {
    bg: "bg-yellow",
    text: "text-yellow",
    hex: "#FFD336",
  },
  yellowLight: {
    bg: "bg-yellow-light",
    text: "text-yellow-light",
    hex: "#FFE99A",
  },
  green: {
    bg: "bg-green",
    text: "text-green",
    hex: "#68D443",
  },
  greenLight: {
    bg: "bg-green-light",
    text: "text-green-light",
    hex: "#B3E9A1",
  },
  pink: {
    bg: "bg-pink",
    text: "text-pink",
    hex: "#FF6998",
  },
  pinkLight: {
    bg: "bg-pink-light",
    text: "text-pink-light",
    hex: "#FFB4CB",
  },
  purple: {
    bg: "bg-purple",
    text: "text-purple",
    hex: "#8B8AE2",
  },
  purpleLight: {
    bg: "bg-purple-light",
    text: "text-purple-light",
    hex: "#C5C4F0",
  },
  blue: {
    bg: "bg-blue",
    text: "text-blue",
    hex: "#3FA2F8",
  },
  blueLight: {
    bg: "bg-blue-light",
    text: "text-blue-light",
    hex: "#9FD0FB",
  },
  orange: {
    bg: "bg-orange",
    text: "text-orange",
    hex: "#FF8928",
  },
  orangeLight: {
    bg: "bg-orange-light",
    text: "text-orange-light",
    hex: "#FFC493",
  },
  red: {
    bg: "bg-red",
    text: "text-red",
    hex: "#FF4A48",
  },
  redLight: {
    bg: "bg-red-light",
    text: "text-red-light",
    hex: "#FFA4A3",
  },
}

export const themedCSSVar = (theme: keyof ThemeType) => {
  return `var(--color-${THEMES[theme]?.bg.replace("bg-", "")})`
}

export const Themed = ({
  children,
  className,
  theme = "yellow",
  type = "bg",
}: {
  children: ReactNode
  className?: string
  theme?: keyof ThemeType
  type?: "bg" | "text"
}) => {
  return <div className={twMerge([THEMES[theme]?.[type], className])}>{children}</div>
}

export const generateThemePalette = (theme: keyof ThemeType) => {
  const c1 = colord(THEMES[theme].hex)
  const c2 = theme === "black" ? c1.lighten(0.1) : c1.saturate(0.2)
  const c3 = c1.darken(0.15)
  const c4 = c2.lighten(0.1)
  const c5 = theme === "black" ? c1.darken(0.1) : c1.desaturate(0.2)
  const c1rgb = c1.toRgb()
  const c2rgb = c2.toRgb()
  const c3rgb = c3.toRgb()
  const c4rgb = c4.toRgb()
  const c5rgb = c5.toRgb()
  return [
    [c1rgb.r, c1rgb.g, c1rgb.b],
    [c2rgb.r, c2rgb.g, c2rgb.b],
    [c3rgb.r, c3rgb.g, c3rgb.b],
    [c4rgb.r, c4rgb.g, c4rgb.b],
    [c5rgb.r, c5rgb.g, c5rgb.b],
  ]
}
